import { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import DashboardDataEntry from '../features/dashboard-v1/DashboardDataEntry';

export const resolveDashboardDataEntryLocationId = (params) =>
  params.id || params['*']?.split('/').filter(Boolean)[0] || null;

const DashboardDataEntryTab = () => {
  const navigate = useNavigate();
  const locationId = resolveDashboardDataEntryLocationId(useParams());

  useEffect(() => {
    if (!locationId) navigate('/');
  }, [locationId, navigate]);

  return locationId ? <DashboardDataEntry locationId={locationId} /> : null;
};

export default DashboardDataEntryTab;
